import styled from 'styled-components'

export const HeroImagePlaceholderStyled = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: ${(props) => props.theme.typography.pxToRem(8)};
  background-color: ${(props) =>
    props.theme.colors.badge.incomplete.background};
`
